(() => {
  const configElement = document.getElementById('StoreIdentityConfig');
  if (!configElement) return;

  const config = configElement.dataset;
  const roots = document.querySelectorAll(
    '.shopify-policy__container, .content-page--return-policy, .content-page--shipment, .content-page--contact'
  );

  if (!roots.length) return;

  const replacements = [
    ['Lansei in China', config.storeName],
    ['Lansei China', config.storeName],
    ['INSONG OÜ', config.storeName],
    ['www.lanseichina.com', config.storeDomain],
    ['chinaesthetics@gmail.com', config.storeEmail],
    ['info@lanseichina.com', config.storeEmail],
    ['Tallinn, Estonia, Antri 12, 10151 Tallinn , Estonia', config.storeAddress],
    ['[INSERT BUSINESS PHONE NUMBER]', config.storePhone],
  ].filter(([, replacement]) => replacement);

  const replaceValue = (value) => {
    let result = value;
    replacements.forEach(([source, replacement]) => {
      result = result.split(source).join(replacement);
    });
    return result;
  };

  roots.forEach((root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) {
      const parentTag = walker.currentNode.parentElement?.tagName;
      if (parentTag !== 'SCRIPT' && parentTag !== 'STYLE') {
        textNodes.push(walker.currentNode);
      }
    }

    textNodes.forEach((node) => {
      const updatedText = replaceValue(node.nodeValue);
      if (updatedText !== node.nodeValue) node.nodeValue = updatedText;
    });

    root.querySelectorAll('a[href]').forEach((link) => {
      const updatedHref = replaceValue(link.getAttribute('href'));
      if (updatedHref !== link.getAttribute('href')) link.setAttribute('href', updatedHref);
    });

    root.querySelectorAll('a').forEach((link) => {
      if (link.textContent.includes('[LINK TO REFUND POLICY]') && config.refundPolicyUrl) {
        link.href = config.refundPolicyUrl;
        link.textContent = 'Refund Policy';
      }

      if (link.textContent.includes('[LINK TO PRIVACY POLICY]') && config.privacyPolicyUrl) {
        link.href = config.privacyPolicyUrl;
        link.textContent = 'Privacy Policy';
      }
    });
  });
})();
